@let inside = this.inside();

<svg [class.back]="inside" width="56" height="56" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="56" height="56" rx="28" fill="#C8102F"/>
  <path d="M36 28H20m0 0 6-6m-6 6 6 6" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
